export default __webpack_public_path__ + "static/media/beach_jog.2c60093c.jpg";